module.exports = __webpack_public_path__ + "media/images/flags/hu-bcbd277021f4a8f5a0591c07a54c9caf.svg";